import Strata from "@/assets/js/strata";
import Saga from "@/assets/js/saga";
import PositionGroups from "@/assets/js/position-groups";
import Sides from "@/assets/js/sides";

export const left = 'LEFT';
export const centre = 'CENTRE';
export const right = 'RIGHT';

export const FULL_BACK = 'DL/DR';
export const CENTRE_BACK = 'DC';
export const WING_BACK = 'WBL/WBR';
export const DEFENSIVE_MIDFIELD = 'DMC';
export const WIDE_MIDFIELD = 'ML/MR';
export const CENTRAL_MIDFIELD = 'MC';
export const WING_FORWARD = 'AML/AMR';
export const ATTACKING_MIDFIELD = 'AMC';
export const CENTRAL_ATTACK = 'STC';

const positions = {
  player1: {
    positionNumber: 1,
    positionName: 'GK',
    stratum: Strata.GK,
    sagum: Saga.central,
    column: 3,
    position: 'GK',
    positionGroup: PositionGroups.goalkeeper,
    goalkeeper: true,
    side: Sides.centre
  },
  player2: { 
    positionNumber: 2,
    positionName: 'DR',
    stratum: Strata.D,
    sagum: Saga.flank,
    column: 5,
    position: 'DR',
    positionGroup: PositionGroups.fullBack,
    side: Sides.right
  },
  player3: {
    positionNumber: 3,
    positionName: 'DL',
    stratum: Strata.D,
    sagum: Saga.flank,
    column: 1,
    position: 'DL',
    positionGroup: PositionGroups.fullBack,
    side: Sides.left
  },
  player4: {
    positionNumber: 4,
    positionName: 'DCl',
    stratum: Strata.D,
    sagum: Saga.central,
    column: 2,
    position: 'DC',
    positionGroup: PositionGroups.centralDefence,
    side: Sides.left
  },
  player5: {
    positionNumber: 5,
    positionName: 'DCc',
    stratum: Strata.D,
    sagum: Saga.central,
    column: 3,
    position: 'DC',
    positionGroup: PositionGroups.centralDefence,
    side: Sides.centre
  },
  player6: {
    positionNumber: 6,
    positionName: 'DCr',
    stratum: Strata.D,
    sagum: Saga.central,
    column: 4,
    position: 'DC',
    positionGroup: PositionGroups.centralDefence,
    side: Sides.right
  },
  player7: {
    positionNumber: 7,
    positionName: 'WBR',
    stratum: Strata.DM,
    sagum: Saga.flank,
    column: 5,
    position: 'WBR',
    positionGroup: PositionGroups.wingBack,
    side: Sides.right
  },
  player8: {
    positionNumber: 8,
    positionName: 'WBL',
    stratum: Strata.DM,
    sagum: Saga.flank,
    column: 1,
    position: 'WBL',
    positionGroup: PositionGroups.wingBack,
    side: Sides.left
  },
  player9: {
    positionNumber: 9,
    positionName: 'DMCl',
    stratum: Strata.DM,
    sagum: Saga.central,
    column: 2,
    position: 'DMC',
    positionGroup: PositionGroups.defensiveMidfield,
    side: Sides.left
  },
  player10: {
    positionNumber: 10,
    positionName: 'DMCc',
    stratum: Strata.DM,
    sagum: Saga.central,
    column: 3,
    position: 'DMC',
    positionGroup: PositionGroups.defensiveMidfield,
    side: Sides.centre
  },
  player11: {
    positionNumber: 11,
    positionName: 'DMCr',
    stratum: Strata.DM,
    sagum: Saga.central,
    column: 4,
    position: 'DMC',
    positionGroup: PositionGroups.defensiveMidfield,
    side: Sides.right
  },
  player12: {
    positionNumber: 12,
    positionName: 'MR',
    stratum: Strata.M,
    sagum: Saga.flank,
    column: 5,
    position: 'MR',
    positionGroup: PositionGroups.wideMidfield,
    side: Sides.right
  },
  player13: {
    positionNumber: 13,
    positionName: 'ML',
    stratum: Strata.M,
    sagum: Saga.flank,
    column: 1,
    position: 'ML',
    positionGroup: PositionGroups.wideMidfield,
    side: Sides.left
  },
  player14: {
    positionNumber: 14,
    positionName: 'MCl',
    stratum: Strata.M,
    sagum: Saga.central,
    column: 2,
    position: 'MC',
    positionGroup: PositionGroups.centralMidfield,
    side: Sides.left
  },
  player15: {
    positionNumber: 15,
    positionName: 'MCc',
    stratum: Strata.M,
    sagum: Saga.central,
    column: 3,
    position: 'MC',
    positionGroup: PositionGroups.centralMidfield,
    side: Sides.centre
  },
  player16: {
    positionNumber: 16,
    positionName: 'MCr',
    stratum: Strata.M,
    sagum: Saga.central,
    column: 4,
    position: 'MC',
    positionGroup: PositionGroups.centralMidfield,
    side: Sides.right
  },
  player17: {
    positionNumber: 17,
    positionName: 'AMR',
    stratum: Strata.AM,
    sagum: Saga.flank,
    column: 5,
    position: 'AMR',
    positionGroup: PositionGroups.wingForward,
    side: Sides.right
  },
  player18: {
    positionNumber: 18,
    positionName: 'AML',
    stratum: Strata.AM,
    sagum: Saga.flank,
    column: 1,
    position: 'AML',
    positionGroup: PositionGroups.wingForward,
    side: Sides.left
  },
  player19: {
    positionNumber: 19,
    positionName: 'AMCl',
    stratum: Strata.AM,
    sagum: Saga.central,
    column: 2,
    position: 'AMC',
    positionGroup: PositionGroups.attackingMidfield,
    side: Sides.left
  },
  player20: {
    positionNumber: 20,
    positionName: 'AMCc',
    stratum: Strata.AM,
    sagum: Saga.central,
    column: 3,
    position: 'AMC',
    positionGroup: PositionGroups.attackingMidfield,
    side: Sides.centre
  },
  player21: {
    positionNumber: 21,
    positionName: 'AMCr',
    stratum: Strata.AM,
    sagum: Saga.central,
    column: 4,
    position: 'AMC',
    positionGroup: PositionGroups.attackingMidfield,
    side: Sides.right
  },
  player22: {
    positionNumber: 22,
    positionName: 'STCl',
    stratum: Strata.ST,
    sagum: Saga.central,
    column: 2,
    position: 'STC',
    positionGroup: PositionGroups.centralAttack,
    side: Sides.left
  },
  player23: {
    positionNumber: 23,
    positionName: 'STCc',
    stratum: Strata.ST,
    sagum: Saga.central,
    column: 3,
    position: 'STC',
    positionGroup: PositionGroups.centralAttack,
    side: Sides.centre
  },
  player24: {
    positionNumber: 24,
    positionName: 'STCr',
    stratum: Strata.ST,
    sagum: Saga.central,
    column: 4,
    position: 'STC',
    positionGroup: PositionGroups.centralAttack,
    side: Sides.right
  }
};

export default positions;
